import { supporters } from '@/data/mockData';
import { motion } from 'framer-motion';

export function SupportersSection() {
  return (
    <section className="border-t py-12 md:py-16 bg-slate-100">
      <div className="container">
        <div className="text-center">
          <p className="text-base font-medium text-muted-foreground">
            The N4 Research Group is supported by grants from
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-8 flex flex-wrap md:flex-nowrap items-center justify-center gap-6 md:gap-8"
        >
          {supporters.map((supporter) => (
            <a
              key={supporter.name}
              href={supporter.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-[170px] md:w-[200px] h-20 md:h-24 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow"
            >
              <img
                src={supporter.logo}
                alt={supporter.name}
                className="max-h-16 md:max-h-18 max-w-[150px] md:max-w-[180px] w-auto h-auto object-contain"
                width={180}
                height={64}
                loading="lazy"
              />
            </a>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
